"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _dateUtils = _interopRequireDefault(require("../../utils/dateUtils"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Days = _interopRequireDefault(require("./Days.style"));

var _dec, _class;

let Days = (_dec = (0, _reactJss.default)(_Days.default), _dec(_class = class Days extends _react.PureComponent {
  // Клик на дату
  handleClickDay(item) {
    const {
      onChange
    } = this.props;
    const {
      day,
      month,
      year,
      disabledDay
    } = item;
    if (disabledDay) return;
    onChange({
      day,
      month,
      year
    });
  } // Двойной клик на дату


  handleDoubleClickDay(item) {
    const {
      onDoubleClick
    } = this.props;
    const {
      day,
      month,
      year,
      disabledDay
    } = item;
    if (disabledDay) return;
    onDoubleClick({
      day,
      month,
      year
    });
  } // Получить количество дней в месяце (month, year)


  getCountDaysMonth(month, year) {
    return 33 - new Date(year, month - 1, 33).getDate();
  }

  isSelected(day, month, year) {
    const {
      startDate,
      endDate
    } = this.props;

    const start = _dateUtils.default.unixtime2Date(startDate);

    const end = _dateUtils.default.unixtime2Date(endDate);

    return day === start.day && month === start.month + 1 && year === start.year || day === end.day && month === end.month + 1 && year === end.year;
  }

  isInRange(day, month, year) {
    const {
      startDate,
      endDate
    } = this.props;
    if (startDate === endDate) return false;

    const unix = _dateUtils.default.dateToUnixtime(new Date(year, month - 1, day));

    return unix >= startDate && unix <= endDate;
  }

  isToday(day, month, year) {
    const today = new Date();
    const currentDay = today.getDate();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    return day === currentDay && month === currentMonth && year === currentYear;
  }

  isStart(day, month, year) {
    const {
      startDate,
      endDate
    } = this.props;

    const start = _dateUtils.default.unixtime2Date(startDate);

    const range = startDate < endDate;
    return range && day === start.day && month === start.month + 1 && year === start.year;
  }

  isEnd(day, month, year) {
    const {
      startDate,
      endDate
    } = this.props;

    const end = _dateUtils.default.unixtime2Date(endDate);

    const range = startDate < endDate;
    return range && day === end.day && month === end.month + 1 && year === end.year;
  }

  isDisabled(day, month, year) {
    const {
      maxDate,
      minDate
    } = this.props;

    const date = _dateUtils.default.dateToUnixtime(new Date(year, month - 1, day));

    if (maxDate) {
      maxDate.setHours(0, 0, 0, 0);

      const max = _dateUtils.default.dateToUnixtime(maxDate);

      if (date > max) return true;
    }

    if (minDate) {
      minDate.setHours(0, 0, 0, 0);

      const min = _dateUtils.default.dateToUnixtime(minDate);

      if (date < min) return true;
    }

    return false;
  }

  render() {
    const {
      isoDays,
      classes,
      className,
      viewDate,
      size
    } = this.props;
    const month = viewDate.getMonth() + 1;
    const year = viewDate.getFullYear();
    const daysInMonth = this.getCountDaysMonth(month, year);
    const firstDay = new Date(year, month - 1, 1).getDay();
    const days = []; // Расчет дней в предыдущем месяце с правкой на локализацию

    let countPrevDays;

    if (isoDays) {
      countPrevDays = firstDay === 0 ? firstDay + 5 : firstDay - 2;
    } else {
      countPrevDays = firstDay - 1;
    } // Дни в предыдущем месяце


    const daysInPrevMonth = this.getCountDaysMonth(month - 1, year);

    for (let i = countPrevDays; i >= 0; i -= 1) {
      days.push({
        day: daysInPrevMonth - i,
        month: month - 1 === 0 ? 12 : month - 1,
        year: month - 1 === 0 ? year - 1 : year,
        actualMonth: false
      });
    } // Дни в текущем месяце


    for (let i = 1; i <= daysInMonth; i += 1) {
      days.push({
        day: i,
        month,
        year,
        actualMonth: true
      });
    } // Дни следующего месяца


    const countNextDays = days.length;

    for (let i = 1; i <= 42 - countNextDays; i += 1) {
      days.push({
        day: i,
        month: month + 1 === 13 ? 1 : month + 1,
        year: month + 1 === 13 ? year + 1 : year,
        actualMonth: false
      });
    }

    return _react.default.createElement("div", {
      className: (0, _clsx.default)(className, classes[size], classes.days)
    }, days.map((item, index) => {
      const {
        actualMonth,
        day,
        month,
        year
      } = item;
      const disabledDay = this.isDisabled(day, month, year);
      const updatedItem = Object.assign({}, item, {
        disabledDay
      });
      const isSelected = this.isSelected(day, month, year);
      const isInRange = this.isInRange(day, month, year);
      const isToday = this.isToday(day, month, year);
      const isStart = this.isStart(day, month, year);
      const isEnd = this.isEnd(day, month, year);
      return _react.default.createElement("div", {
        key: index,
        className: (0, _clsx.default)(className, classes[size], classes.dayContainer, {
          inRange: isInRange && !isSelected
        }, {
          startRange: isStart && isSelected
        }, {
          endRange: isEnd && isSelected
        })
      }, _react.default.createElement("div", {
        className: (0, _clsx.default)(classes.day, {
          disabled: disabledDay
        }, {
          dayToday: isToday && !isSelected && !isInRange
        }, {
          otherMonth: !actualMonth
        }, {
          selected: !disabledDay && isSelected
        }, {
          inRange: isInRange && !isSelected
        }, {
          selectedDisabled: isSelected && disabledDay
        }),
        onClick: () => this.handleClickDay(updatedItem),
        onDoubleClick: () => this.handleDoubleClickDay(updatedItem)
      }, day));
    }));
  }

}) || _class);
var _default = Days;
exports.default = _default;